const ProgressRing = ({ 
  progress = 0, 
  size = 80, 
  strokeWidth = 8, 
  color = "hsl(var(--primary))",
  bgColor = "hsl(var(--muted))"
}) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = radius * 2 * Math.PI;
  const strokeDashoffset = circumference - (progress / 100) * circumference;

  return (
    <svg
      className="progress-ring"
      width={size}
      height={size}
    >
      {/* Background circle */}
      <circle
        stroke={bgColor}
        strokeWidth={strokeWidth}
        fill="transparent"
        r={radius}
        cx={size / 2}
        cy={size / 2}
      />
      {/* Progress circle */}
      <circle
        className="progress-ring-circle ring-animate"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        fill="transparent"
        r={radius}
        cx={size / 2}
        cy={size / 2}
        style={{
          strokeDasharray: circumference,
          strokeDashoffset: strokeDashoffset,
        }}
      />
      {/* Center text */}
      <text
        x="50%"
        y="50%"
        textAnchor="middle"
        dominantBaseline="central"
        className="text-sm font-bold fill-current"
        style={{ transform: 'rotate(90deg)', transformOrigin: 'center' }}
      >
        {Math.round(progress)}%
      </text>
    </svg>
  );
};

export default ProgressRing;
